"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const messages_1 = require("./messages");
const constants_1 = require("./constants");
const handler_1 = require("./handler");
function init(router, service) {
    router.registerMessage(messages_1.RestoreKeyRingMsg);
    router.registerMessage(messages_1.DeleteKeyRingMsg);
    router.registerMessage(messages_1.UpdateNameKeyRingMsg);
    router.registerMessage(messages_1.ShowKeyRingMsg);
    router.registerMessage(messages_1.CreateMnemonicKeyMsg);
    router.registerMessage(messages_1.AddMnemonicKeyMsg);
    router.registerMessage(messages_1.CreatePrivateKeyMsg);
    router.registerMessage(messages_1.AddPrivateKeyMsg);
    router.registerMessage(messages_1.CreateLedgerKeyMsg);
    router.registerMessage(messages_1.AddLedgerKeyMsg);
    router.registerMessage(messages_1.LockKeyRingMsg);
    router.registerMessage(messages_1.UnlockKeyRingMsg);
    router.registerMessage(messages_1.GetKeyMsg);
    router.registerMessage(messages_1.RequestSignAminoMsg);
    router.registerMessage(messages_1.RequestVerifyADR36AminoSignDoc);
    router.registerMessage(messages_1.RequestSignDirectMsg);
    router.registerMessage(messages_1.GetMultiKeyStoreInfoMsg);
    router.registerMessage(messages_1.ChangeKeyRingMsg);
    router.registerMessage(messages_1.GetIsKeyStoreCoinTypeSetMsg);
    router.registerMessage(messages_1.SetKeyStoreCoinTypeMsg);
    router.registerMessage(messages_1.CheckPasswordMsg);
    router.registerMessage(messages_1.ExportKeyRingDatasMsg);
    router.addHandler(constants_1.ROUTE, handler_1.getHandler(service));
}
exports.init = init;
//# sourceMappingURL=init.js.map